import React from "react"
import PropTypes from "prop-types"

class HelloMessage extends React.Component {
  render() {
    return (
      <React.Fragment>
        <h1>Hello {this.props.name}!</h1>
        <p> Hello Message Component</p>
      </React.Fragment>
    );
  }
}

HelloMessage.propTypes = {
  name: PropTypes.string
};
export default HelloMessage
